import {
  CubeReducerState,
  VisibleEnabledFeatureAvailable
} from 'modules/Cube/domain/cube.domain.types'

export const getMemoAvailable = (
  _prevState: CubeReducerState
): VisibleEnabledFeatureAvailable => ({
  available: {
    visible: true,
    enabled: true
  },
  reasons: []
})
